import { useState } from "react";
import { useTranslation } from "react-i18next";

function Gender({ question, onSubmitHandler, selectedGender = null }) {
  const [gender, setGender] = useState(selectedGender);
  const { t } = useTranslation();

  const handleChange = (e) => setGender(e.target.value);

  return (
    <div className="body_content">
      <div className="inner_body ">
        <h3 className="headtitle">{question}</h3>
        <ul className="list-unstyled list_gender_radio">
          <li>
            <label className="field_lbl_radio">
              <input
                type="radio"
                name="gender"
                value="Male"
                onChange={handleChange}
                checked={gender === "Male"}
              />
              <div className="box_radio">
                <span className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="23.731"
                    viewBox="0 0 18 23.731"
                  >
                    <g
                      id="Group_153"
                      data-name="Group 153"
                      transform="translate(-579.751 196.867)"
                    >
                      <g
                        id="male-avatar"
                        transform="translate(579.751 -196.867)"
                      >
                        <path
                          className="icon_path"
                          id="Path_13"
                          data-name="Path 13"
                          d="M76.157,9.253a2.174,2.174,0,0,0,1.28-1.561,1.892,1.892,0,0,0-.889-2.32,3.554,3.554,0,0,0,.1-.861C76.65,2.021,74.164,0,71.093,0s-5.557,2.021-5.557,4.512a3.848,3.848,0,0,0,.147,1.031,2.051,2.051,0,0,0-.571,2.15,2.156,2.156,0,0,0,1.28,1.561c.691,2.274,2.468,4.636,4.88,4.636S75.467,11.527,76.157,9.253Zm-4.88,3.826c-1.97,0-3.582-2.145-4.162-4.267l-.074-.258-.262-.037a1.265,1.265,0,0,1-.875-1.022,1.528,1.528,0,0,1,.124-1.142.554.554,0,0,1,.318-.258.464.464,0,0,1,.087-.009.372.372,0,0,1,.069,0l.382.037.055-.377a6.075,6.075,0,0,1,.714-2.1,4.687,4.687,0,0,0,3.43,1.229,4.306,4.306,0,0,0,3.641-1.515,5.867,5.867,0,0,1,.9,2.4l.055.377.382-.037a.575.575,0,0,1,.157,0,.257.257,0,0,1,.074.032c.35.157.52.764.373,1.367a1.279,1.279,0,0,1-.875,1.022l-.267.037-.074.258C74.868,10.929,73.248,13.079,71.278,13.079Zm1.634,1.284-1.114.548a.545.545,0,0,0-.479-.354.577.577,0,0,0-.5.387l-1.174-.575c-.534-.262-.976.046-.976.7a1.01,1.01,0,0,0,.138.534.682.682,0,0,0,.64.341.731.731,0,0,0,.23-.046l1.109-.377a.594.594,0,0,0,.525.479.58.58,0,0,0,.52-.456l1.04.35a.9.9,0,0,0,.391.041.651.651,0,0,0,.377-.2.955.955,0,0,0,.244-.672C73.888,14.414,73.451,14.1,72.912,14.363Zm3.176-.069a5.082,5.082,0,0,1-1.934,2.058c-1.657.847-2.886,1.538-2.886,1.538l0,0v-.014l-.014.009-.014-.009v.014l0,0S70,17.2,68.345,16.352a5.083,5.083,0,0,1-1.934-2.058c-2.454.994-4.162,3.292-4.162,5.285v4.152h18V19.579C80.25,17.581,78.537,15.288,76.088,14.294Z"
                          transform="translate(-62.25)"
                          fill="rgba(0,0,0,0.3)"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
                <span className="txt">{t("onboard.GENDER.options.male")}</span>
              </div>
            </label>
          </li>
          <li>
            <label className="field_lbl_radio">
              <input
                type="radio"
                name="gender"
                value="Female"
                onChange={handleChange}
                checked={gender === "Female"}
              />
              <div className="box_radio">
                <span className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="24.192"
                    viewBox="0 0 18 24.192"
                  >
                    <g
                      id="Group_157"
                      data-name="Group 157"
                      transform="translate(-781.972 196.867)"
                    >
                      <g
                        id="woman-avatar"
                        transform="translate(781.972 -196.867)"
                      >
                        <g
                          id="Group_26"
                          data-name="Group 26"
                          transform="translate(0)"
                        >
                          <path
                            className="icon_path"
                            id="Path_15"
                            data-name="Path 15"
                            d="M119.434,14.148A18.769,18.769,0,0,0,122.84,14a2.981,2.981,0,0,0,1.471,0c3.325.162,5.917,1.1,5.917-5.666,0-4.594-2.984-8.325-6.665-8.325S116.9,3.731,116.9,8.325c0,3.695.707,5.13,1.854,5.63A2.46,2.46,0,0,0,119.434,14.148Zm-1.062-8.419c.7.967,2.507.761,4.068-.464a5.949,5.949,0,0,0,1.021-1.026.9.9,0,0,1,.108.018,3.6,3.6,0,0,1,.45.131,4.138,4.138,0,0,1,.427.207,3.9,3.9,0,0,1,.392.257,3.589,3.589,0,0,1,.333.3,2.373,2.373,0,0,1,.265.31,3.042,3.042,0,0,1,.2.293,1.369,1.369,0,0,1,.135.243c.068.139.108.22.108.22s-.014-.085-.04-.243a2.236,2.236,0,0,0-.058-.279,2.333,2.333,0,0,0-.113-.36,3.463,3.463,0,0,0-.18-.409,4.641,4.641,0,0,0-.261-.437,5.039,5.039,0,0,0-.351-.427,4.491,4.491,0,0,0-.427-.4A4.475,4.475,0,0,0,124,3.375a3.52,3.52,0,0,0,.166-.419,5.289,5.289,0,0,1,1.584,1.026c1.67,1.669,1.012,3.609,2.3,2.326a3.462,3.462,0,0,0,.5-.625.569.569,0,0,1,.126,0,.592.592,0,0,1,.351.288,1.529,1.529,0,0,1,.108,1.138,1.3,1.3,0,0,1-.909,1.044l-.27.036-.072.266c-.639,2.317-2.363,4.784-4.311,4.784s-3.667-2.466-4.311-4.784l-.072-.266-.27-.036a1.321,1.321,0,0,1-.909-1.044,1.529,1.529,0,0,1,.108-1.138A.605.605,0,0,1,118.372,5.728Z"
                            transform="translate(-114.735)"
                            fill="rgba(0,0,0,0.3)"
                          />
                          <path
                            className="icon_path"
                            id="Path_16"
                            data-name="Path 16"
                            d="M82.637,327.9a5.1,5.1,0,0,1-1.93,2.056c-1.656.846-2.889,1.539-2.889,1.539l0,0v-.014l-.013.009-.013-.009v.014l0,0s-1.229-.684-2.889-1.539a5.126,5.126,0,0,1-1.93-2.056c-2.453,1-4.162,3.285-4.162,5.288v4.149h18v-4.149C86.8,331.189,85.085,328.9,82.637,327.9Z"
                            transform="translate(-68.8 -313.145)"
                            fill="rgba(0,0,0,0.3)"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
                <span className="txt">
                  {t("onboard.GENDER.options.female")}
                </span>
              </div>
            </label>
          </li>
          <li>
            <label className="field_lbl_radio">
              <input
                type="radio"
                name="gender"
                value="Other"
                onChange={handleChange}
                checked={gender === "Other"}
              />
              <div className="box_radio">
                <span className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24.981"
                    height="26.422"
                    viewBox="0 0 24.981 26.422"
                  >
                    <g
                      id="Group_158"
                      data-name="Group 158"
                      transform="translate(-668.254 192.867)"
                    >
                      <g
                        id="transgender"
                        transform="translate(668.254 -192.867)"
                      >
                        <path
                          className="icon_path"
                          id="Path_14"
                          data-name="Path 14"
                          d="M38.509.429,33.322,0l-.128,1.543,2.869.237L31.238,6.606a7.6,7.6,0,0,0-9.58,0L20.206,5.154l1.367-1.367L20.477,2.692,19.111,4.059l-2.3-2.3,2.606-.216L19.289,0,14.364.408l-.408,4.925L15.5,5.46l.216-2.606,2.3,2.3L16.649,6.52l1.095,1.095,1.367-1.367L20.561,7.7a7.6,7.6,0,0,0,5.112,12.364v2.721H23.548v1.548h2.125v2.089h1.548V24.333h2.125V22.785H27.222V20.064A7.6,7.6,0,0,0,32.334,7.7l4.824-4.824L37.4,5.745l1.543-.128Z"
                          transform="translate(-13.957)"
                          fill="rgba(0,0,0,0.3)"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
                <span className="txt">{t("onboard.GENDER.options.other")}</span>
              </div>
            </label>
          </li>
        </ul>
        <div className="btn_block bottom_button d-flex justify-content-center">
          <button
            className="btn btn_primary"
            disabled={gender === null}
            onClick={() => onSubmitHandler(gender)}
          >
            {t("login.DOBSTEP.button")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Gender;
